import * as AvatarPrimitive from "@radix-ui/react-avatar";
import clsx from "clsx";
import * as React from "react";

const Avatar = React.forwardRef<React.ElementRef<typeof AvatarPrimitive.Root>, React.ComponentPropsWithoutRef<typeof AvatarPrimitive.Root>>(
	({ className, ...props }, ref) => (
		<AvatarPrimitive.Root ref={ref} className={clsx("relative flex h-10 w-10 shrink-0 overflow-hidden", className)} {...props} />
	),
);
Avatar.displayName = AvatarPrimitive.Root.displayName;

const AvatarImage = React.forwardRef<React.ElementRef<typeof AvatarPrimitive.Image>, React.ComponentPropsWithoutRef<typeof AvatarPrimitive.Image>>(
	({ className, ...props }, ref) => <AvatarPrimitive.Image ref={ref} className={clsx("aspect-square h-full w-full", className)} {...props} />,
);
AvatarImage.displayName = AvatarPrimitive.Image.displayName;

const AvatarFallback = React.forwardRef<React.ElementRef<typeof AvatarPrimitive.Fallback>, React.ComponentPropsWithoutRef<typeof AvatarPrimitive.Fallback>>(
	({ className, ...props }, ref) => (
		<AvatarPrimitive.Fallback
			ref={ref}
			className={clsx("flex h-full w-full items-center justify-center bg-transparent text-white font-semibold", className)}
			{...props}
		/>
	),
);
AvatarFallback.displayName = AvatarPrimitive.Fallback.displayName;

export { Avatar, AvatarImage, AvatarFallback };
